// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2KZH5","container":"styles_container__29iuU","title":"styles_title__30M9f","wrapper":"styles_wrapper__3MixW","answer":"styles_answer__nbvRl"};